// Pure assist-level types + gates (no DOM). Shared by client + server.

export const ACTIVITY_DOCK_ASSIST_LEVEL_STORAGE_KEY =
  "bb-setting-dock-assist-level";

export const ACTIVITY_DOCK_ASSIST_LEVELS = [
  "off",
  "minimal",
  "standard",
  "proactive",
] as const;

export type ActivityDockAssistLevel =
  (typeof ACTIVITY_DOCK_ASSIST_LEVELS)[number];

export const ACTIVITY_DOCK_ASSIST_LEVEL_DEFAULT: ActivityDockAssistLevel =
  "standard";

export type AssistLevelDescription = {
  id: ActivityDockAssistLevel;
  label: string;
  blurb: string;
};

export const ACTIVITY_DOCK_ASSIST_LEVEL_DESCRIPTIONS: readonly AssistLevelDescription[] =
  [
    {
      id: "off",
      label: "Off",
      blurb:
        "Firefly never opens the activity panel on its own. You can still open it manually.",
    },
    {
      id: "minimal",
      label: "Minimal",
      blurb:
        "Firefly opens the panel only for first-login welcomes and when a new lead with missing fields is opened.",
    },
    {
      id: "standard",
      label: "Standard (recommended)",
      blurb:
        "Firefly may peek briefly when you switch modes and has something urgent to surface.",
    },
    {
      id: "proactive",
      label: "Proactive",
      blurb:
        "Firefly offers predictive nudges based on time-of-day and recent activity. (Future — currently behaves like Standard.)",
    },
  ];

export function parseAssistLevel(
  value: unknown,
  fallback: ActivityDockAssistLevel = ACTIVITY_DOCK_ASSIST_LEVEL_DEFAULT,
): ActivityDockAssistLevel {
  if (typeof value !== "string") return fallback;
  const match = ACTIVITY_DOCK_ASSIST_LEVELS.find((level) => level === value);
  return match ?? fallback;
}

export function canPeekOnModeChange(level: ActivityDockAssistLevel): boolean {
  return level === "standard" || level === "proactive";
}

export function canHandleExplicitDockOpen(
  level: ActivityDockAssistLevel,
): boolean {
  return level !== "off";
}
